module.exports = __webpack_public_path__ + "static/felix-d574f75bdf40dc2254a8c4237b7e4692.png";